import { propStyles } from 'src/utils/propStyles';
import { styled } from 'src/utils/styled';

const FilterDropdownWrapper = styled<any, any>(
    'div',
    'filterDropdownWrapper',
    'filterItemDropdown'
)`
    ${propStyles};
`;

FilterDropdownWrapper.defaultProps = {
    flex: ['0 0 100%', '0 0 33%', '0 0 20%'],
    maxWidth: ['100%', '33%', '20%'],
};

export default FilterDropdownWrapper;



// WEBPACK FOOTER //
// ./src/Components/Filters/Components/StyledComponents/FilterDropdownWrapper.tsx